export const JobCommentValidation = (formData) => {
    const errors = {};

    if (!formData.Comment || !formData.Comment.trim()) {
        errors.Comment = 'This field is required';
    }

    
    return errors;
};
